module.exports = __webpack_public_path__ + "static/media/loader.25a05d05.gif";